import React from "react";

const pills = [
  "Social Media Strategy & Management",
  "Personal Branding Management",
  "SEO Services",
  "GEO Optimization",
  "Google Ads",
  "Meta Ads",
];

export default function ServicesPills() {
  return (
    <section className="services-pills" id="services">
      <div className="section-inner">
        <p className="section-tag">Our Core Services</p>
        <h2>Growth engines tuned for speed and clarity.</h2>
        <div className="pill-grid">
          {pills.map((pill) => (
            <span key={pill}>{pill}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
